// extracted by mini-css-extract-plugin
module.exports = {"root":"heading_root__rNAPy"};